if(!customElements.get('model-buttons')) {
  class ComponentModelButtons extends HTMLElement {
    constructor() {
      super();
      this.btns = this.querySelectorAll('.link');
      this.lastActiveBtn = this.btns[0];

      this.btns.forEach(btn => {

        btn.addEventListener('click', () => {
          this.lastActiveBtn.classList.remove('active');
          this.lastActiveBtn = btn;

          btn.classList.add('active');

          if(btn.dataset.model == "true"){
            document.body.classList.add('model-product-view');
          }
          else{
            document.body.classList.remove('model-product-view');
          }
          
        });

      });

    }



  }
  customElements.define('model-buttons', ComponentModelButtons);
}